import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withRouter } from "react-router-dom";
import { addZone, renameZone, renameDashboardApi } from "../api";
import { setNewDashboardZone, updateZone, renameDashboard } from "../redux";
import { Alert } from "../shared";
import { useTranslation } from "react-i18next";

const AddDetailsComp = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardDetails = useSelector((state) => state.dashboardDetails);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const zoneWidget = useSelector((state) => state.zoneWidgets.zoneWidgets);
  // console.log(zoneWidget);
  // console.log(dashboardZones);
  const [zoneIndex, setZoneIndex] = useState(null);
  const [showAddZone, setShowAddZone] = useState(false);
  const form = useRef(null);
  const formEdit = useRef(null);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  const initialValues = {
    zone_caption: "",
  };

  const submitForm = () => {
    const formData = new FormData(form.current);
    formData.append("dashboard", dashboardDetails.id);
    addZone(formData, token)
      .then((res) => {
        // console.log(res);
        setShowAddZone(false);
        dispatch(
          setNewDashboardZone({
            id: res.data.data,
            zone_caption: formData.get("zone_caption"),
          })
        );
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchema = Yup.object({
    zone_caption: Yup.string().required(t("نام اتاق را وارد کنید.")),
  });

  const initialRenameValues = {
    dashboard_caption: "",
  };

  const submitRenameForm = () => {
    const formData = new FormData(formEdit.current);
    formData.append("dashboard", dashboardDetails.id);
    renameDashboardApi(formData, token)
      .then((res) => {
        formEdit.current.reset();
        dispatch(
          renameDashboard({
            id: res.data.data,
            dashboard_caption: formData.get("dashboard_caption"),
          })
        );
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("خانه با موفقیت ویرایش شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 5000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchemaRename = Yup.object({
    dashboard_caption: Yup.string().required(t("نام ساختمان را وارد کنید.")),
  });

  const [zone, setZone] = useState({
    zones: [],
    id: null,
    index: null,
  });

  const onChangeRenameZone = (id, index, event) => {
    var zones = zone.zones.slice();
    zones[index] = event.target.value;
    setZone({ zones: zones, id: id, index: index });
  };

  const submitRenameZone = () => {
    const formData = new FormData();
    formData.append("zone", zone.id);
    formData.append("zone_caption", zone.zones[zone.index]);
    renameZone(formData, token)
      .then(() => {
        dispatch(
          updateZone({ id: zone.id, zone_caption: zone.zones[zone.index] })
        );
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("اتاق با موفقیت ویرایش شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 3000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const deleteZone = (id) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var formdata = new FormData();
    formdata.append("zone", id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://assessn.mmaviot.com/api/zone_widgets", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        result.data.length
          ? setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t(
                "این ناحیه حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد."
              ),
              type: "Warning",
              question: false,
            }))
          : setShowAlert((prevState) => ({
              ...prevState,
              show: true,
              message: t("آیا از حذف این اتاق اطمینان دارید؟"),
              type: "Warning",
              question: true,
              id: id,
              request: "zone",
            }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 10000);
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <>
      <div className="mt-4">
        <Formik
          initialValues={initialRenameValues}
          onSubmit={submitRenameForm}
          validationSchema={validationSchemaRename}
        >
          {(props) => (
            <Form ref={formEdit}>
              <div className="mt-4">
                <div className="homeName w-100 bg-white">
                  <p className="text-right p-2 m-0 fn12">{t("نام ساختمان")}</p>
                  <input
                    type="text"
                    defaultValue={dashboardDetails.dashboard_caption}
                    className="w-100 border-0 text-center p-2 fn10"
                    name="dashboard_caption"
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                  />
                </div>
                <ErrorMessage name="dashboard_caption">
                  {(errMsg) => (
                    <div className="text-danger text-right fn10 mt-1">
                      {errMsg}
                    </div>
                  )}
                </ErrorMessage>
                <div className="d-flex flex-wrap justify-content-end mt-1">
                  <button
                    type="submit"
                    className="border-0 bg-transparent d-flex justify-content-center align-items-center flex-column text-center"
                  >
                    <span
                      style={{
                        width: "33px",
                        height: "33px",
                        fontSize: "16px",
                      }}
                      className="profileAddUser bg-white d-block icon-ok cursor"
                    ></span>
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="mt-4">
        <div className="d-flex justify-content-between mb-2 fn12">
          <p>{t("اتاق")}</p>
          <span
            className="homeIcon shadow-sm d-flex align-items-center justify-content-center rounded-circle bg-white text-center cursor"
            onClick={() => setShowAddZone(true)}
          >
            +
          </span>
        </div>
        {showAddZone && (
          <Formik
            initialValues={initialValues}
            onSubmit={submitForm}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form ref={form}>
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <input
                    type="text"
                    placeholder={t("اتاق جدید")}
                    name="zone_caption"
                    className="input fn10 w-87 bg-white text-center"
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                  />
                  <span className="homeIcon d-flex align-items-center justify-content-center rounded-circle bg-priimary cursor">
                    <button
                      type="submit"
                      className="bg-transparent text-white border-0"
                    >
                      <i className="icon-ok"></i>
                    </button>
                  </span>
                  <ErrorMessage name="zone_caption">
                    {(errMsg) => (
                      <div className="text-danger fn10 mt-1">{errMsg}</div>
                    )}
                  </ErrorMessage>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
      <div className="mb-5">
        {dashboardZones?.map((zone, index) => {
          const enable = zoneIndex === index ? true : false;
          return (
            <div
              className="w-100 mt-3 position-relative d-flex justify-content-between align-items-center"
              key={index}
            >
              {!enable ? (
                <div
                  className="input fn10 bg-white text-center"
                  style={{ lineHeight: "3.8", width: "90%" }}
                >
                  {zone.zone_caption}
                </div>
              ) : (
                <input
                  type="text"
                  readOnly={!enable}
                  defaultValue={zone.zone_caption}
                  className="input fn10 w-100 bg-white text-center"
                  style={{ lineHeight: "3.8" }}
                  onChange={(event) =>
                    onChangeRenameZone(zone.id, index, event)
                  }
                />
              )}
              <span
                onClick={() => deleteZone(zone.id)}
                className="deleteIcon shadow-sm cursor text-center bg-white position-absolute d-block"
                style={{ left: "35px" }}
              >
                <i className="icon-trash-empty"></i>
              </span>
              <span
                className="editIcon shadow-sm cursor text-center bg-white position-absolute d-block"
                style={{ left: "57px" }}
                onClick={() => setZoneIndex(index)}
              >
                <i className="icon-pencil"></i>
              </span>
              <span
                className="homeIcon shadow-sm d-flex 
                            align-items-center justify-content-center 
                            rounded-circle bg-white text-center cursor icon-ok"
                onClick={submitRenameZone}
              ></span>
            </div>
          );
        })}
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          id={showAlert.id}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}{" "}
    </>
  );
};

const AddDetails = withRouter(AddDetailsComp);

export { AddDetails };
